module.exports = __webpack_public_path__ + "img/logo_min.0c714ae6.svg";